import { useState } from "react";
import { useHistory } from "react-router-dom";
import { processHandler } from "../chatbot";
import { timestamp, uuid } from "../messageFactory";
import { useCreateChatMessage } from "../queries";

export const useChat = () => {
  const history = useHistory();

  const [sessionId, setSessionId] = useState(null);
  const [conversationType, setConversationType] = useState(null);
  const [productArea, setProductArea] = useState(null);
  const [isUserInputEnabled, setIsUserInputEnabled] = useState(false);
  const [isConversationEnded, setIsConversationEnded] = useState(false);
  const [messages, setMessages] = useState([]);

  const addMessage = (type, { ...attributes }) => {
    setMessages(oldMessages => [
      ...oldMessages,
      {
        id: uuid(),
        type,
        createdAt: timestamp(),
        ...attributes,
      },
    ]);
  };

  const { mutate: createChatMessage } = useCreateChatMessage({
    onSuccess: data => {
      setSessionId(data.result.session_id);
      setIsUserInputEnabled(true);

      addMessage("bot", {
        content: data.result.answer,
        buttons: [],
      });
    },
  });

  const process = processHandler({
    history,
    addMessage,
    setIsUserInputEnabled,
    setConversationType,
    setProductArea,
    conversationType,
    productArea,
    createChatMessage,
    sessionId,
    setSessionId,
    setIsConversationEnded,
  });

  return {
    sessionId,
    conversationType,
    messages,
    isUserInputEnabled,
    isConversationEnded,
    process,
  };
};
